module.exports = __webpack_public_path__ + "img/ic_co2.02aa8f74.png";